export default __webpack_public_path__ + "static/media/bookingdetailsnew.4b328a8a.svg";